import React from 'react';
import CustomInput from '../../../../../../components/CustomInput';

export default function EmailTypeAddressInputs({
    data,
    flag,
    onChange,
    onChangeDataStore,
}) {
    return (
        <>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`from_address_${flag}`}
                    placeholder="Enter from address"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeDataStore(e, flag);
                    }}
                    inputValue={data?.[flag]?.from_address}
                    labelText="From address"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`from_name_${flag}`}
                    placeholder="Enter from name"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeDataStore(e, flag);
                    }}
                    inputValue={data?.[flag]?.from_name}
                    labelText="From name"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`reply_to_${flag}`}
                    placeholder="Enter reply to"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeDataStore(e, flag);
                    }}
                    inputValue={data?.[flag]?.reply_to}
                    labelText="Reply to"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`full_address_${flag}`}
                    placeholder="Enter postal address"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeDataStore(e, flag);
                    }}
                    inputValue={data?.[flag]?.full_address}
                    labelText="Postal address"
                    width="100%"
                />
            </div>
        </>
    );
}
